import { twMerge } from "tailwind-merge";
import type { BaseProps, ContainerProps } from "./types";

export type ColumnProps = BaseProps & ContainerProps;

export const Column = ({ className, children, ...props }: ColumnProps) => {
  return (
    <div className={twMerge("flex flex-col gap-4", className)} {...props}>
      {children}
    </div>
  );
};
